import React, { useEffect } from "react";

const ClientAreaOne = () => {
  useEffect(() => {
    const container = document.getElementById("leal-booking-widget");
    if (!container) return;

    let iframe = container.querySelector("iframe");
    if (!iframe) {
      iframe = document.createElement("iframe");
      iframe.src = "https://api.lealchapaypintura.com/embed";
      iframe.style.cssText = "width:100%;max-width:700px;border:none;";
      iframe.height = "720";
      iframe.setAttribute("title", "Reservar Cita");
      iframe.setAttribute("loading", "lazy");
      container.appendChild(iframe);
    }

    const handleMessage = (e) => {
      if (!e.data || e.data.type !== "leal-resize") return;
      const nextHeight = Number(e.data.height);
      if (!Number.isFinite(nextHeight) || nextHeight <= 0) return;
      iframe.style.height = nextHeight + "px";
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <div
      className="client-bg-area"
      style={{ backgroundImage: "url(/assets/img/bg/client-bg1-1.png)" }}
    >
      {/* <div className="client-area-1 text-center">
        <div className="container">
          <div className="row global-carousel">
            <Swiper
              spaceBetween={20}
              slidesPerGroup={2}
              speed={1000}
              autoplay={{ delay: 6000 }}
              className="mySwiper"
              breakpoints={{
                0: {
                  slidesPerView: 2,
                },
                500: {
                  slidesPerView: 2,
                },
                768: {
                  slidesPerView: 3,
                },
                992: {
                  slidesPerView: 4,
                },
                1200: {
                  slidesPerView: 5,
                },
                1400: {
                  slidesPerView: 5,
                },
              }}
            >
              <SwiperSlide>
                <div className="col-lg-auto">
                  <div className="client-logo">
                    <Link to="/">
                      <img src="assets/img/client/1-1.png" alt="LealChapayPintura.com" />
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="col-lg-auto">
                  <div className="client-logo">
                    <Link to="/">
                      <img src="assets/img/client/1-2.png" alt="LealChapayPintura.com" />
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="col-lg-auto">
                  <div className="client-logo">
                    <Link to="/">
                      <img src="assets/img/client/1-3.png" alt="LealChapayPintura.com" />
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="col-lg-auto">
                  <div className="client-logo">
                    <Link to="/">
                      <img src="assets/img/client/1-4.png" alt="LealChapayPintura.com" />
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="col-lg-auto">
                  <div className="client-logo">
                    <Link to="/">
                      <img src="assets/img/client/1-5.png" alt="LealChapayPintura.com" />
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="col-lg-auto">
                  <div className="client-logo">
                    <Link to="/">
                      <img src="assets/img/client/1-1.png" alt="LealChapayPintura.com" />
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="col-lg-auto">
                  <div className="client-logo">
                    <Link to="/">
                      <img src="assets/img/client/1-2.png" alt="LealChapayPintura.com" />
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="col-lg-auto">
                  <div className="client-logo">
                    <Link to="/">
                      <img src="assets/img/client/1-3.png" alt="LealChapayPintura.com" />
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="col-lg-auto">
                  <div className="client-logo">
                    <Link to="/">
                      <img src="assets/img/client/1-4.png" alt="LealChapayPintura.com" />
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="col-lg-auto">
                  <div className="client-logo">
                    <Link to="/">
                      <img src="assets/img/client/1-5.png" alt="LealChapayPintura.com" />
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div> */}
      {/*==============================
    Contact Area - WhatsApp CTA
    ==============================*/}
      <div className="appointment-area-1 overflow-hidden">
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              <div className="appointment-form-wrap bg-theme">
                <div className="title-area mb-4">
                  <span className="sub-title text-white">Contáctanos</span>
                  <h2 className="sec-title text-white">
                    En tú taller de confianza
                  </h2>
                  <p className="text-white mb-0">
                    Ponte en contacto con nosotros de forma rápida y sencilla. Estaremos encantados de atenderte.
                  </p>
                </div>
                {/* Leal Chapa y Pintura - Widget de Reservas */}
                <div className="booking-widget-section text-center py-4">
                  <div id="leal-booking-widget"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="appointment-thumb-1">
          <img
            src="/assets/img/normal/appointment-thumb-1-1.png"
            alt="LealChapaYPintura"
          />
        </div>
      </div>
    </div>
  );
};

export default ClientAreaOne;
